export function isImage(url: string): boolean {
  return /\.(jpeg|jpg|png|gif|bmp|webp)$/i.test(url);
}

export function isVideo(url: string): boolean {
  return /\.(mp4|webm|ogg)$/i.test(url);
}

export async function preloadAsset(url: string): Promise<Blob> {
  const response = await fetch(url, {
    mode: 'cors',
    cache: 'force-cache',
    headers: { 'Cache-Control': 'max-age=3600' },
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  return await response.blob();
}

export function preloadVideos(videoList: string[]) {
  videoList.forEach((url) => {
    if (isVideo(url)) {
      const video = document.createElement('video');
      video.src = url;
      video.preload = 'auto';
      video.load();
    }
  });

  return;
}
